import tw from 'tailwind-styled-components'

interface InfoTextProps {
    $bold?: boolean
}

export const InfoWrapper = tw.div`
flex 
flex-wrap
justify-between
`

export const InfoBox = tw.div`
flex 
flex-wrap
flex-row 
gap-8
`

export const InfoContent = tw.div`
flex
flex-col
`

export const InfoTextTitle = tw.span`
text-xs
text-darkGray/80
`

export const InfoText = tw.span<InfoTextProps>`
${(props) =>
    props.$bold ? 'font-bold text-regular uppercase' : 'font-semibold text-sm'}
text-darkGray
`

export const Attachment = tw.div`
flex 
flex-row 
items-center 
justify-center 
w-full 
h-[38px] 
border-[2px] 
border-dashed 
border-blueTheme 
rounded-lg 
cursor-pointer
hover:brightness-75
transition-all
justify-center
border 
rounded-[8px]
w-[450px]
h-[38px]
`

export const RedCircle = tw.span`
px-2
py-1
bg-errorText
rounded-[14px]
font-semibold
text-sm
text-white
`
export const TimeText = tw.span`
inline-flex
items-center
mt-3.5
gap-1
text-sm
font-medium
text-amberAlt
`

export const InfoDivider = tw.div`
h-px 
bg-borderLine 
mx-6
my-4
`

export const InputInfoLabelTitle = tw.p`
font-semibold
text-xs
text-darkGray
`

export const InputInfoLabelType = tw.p`
font-semibold
text-sm
text-darkGray
`

export const InfoInputsWrapper = tw.div`
px-8
overflow-y-auto
overflow-x-hidden
flex
flex-col
gap-6
max-h-[55vh]
custom-scrollbar-larger
pb-1
`

export const InputInfoLabelSubTitle = tw.p`
text-xs
text-darkGray/80
`
export const observationTextAreaStyles = `
max-w-full 
max-h-[120px] 
h-[120px]
`
export const textAreaStyles = `
max-w-full 
max-h-[257px] 
h-[257px]
`
export const textAreaSmallStyles = `
max-w-full 
max-h-[105px] 
h-[105px]
`

export const Grid = tw.div`
grid
gap-4
`

export const PatientWrapper = tw.div`
xl:flex
flex-row 
gap-[70px]
`

export const BlueText = tw.span`
text-blueTheme
font-semibold
text-sm
`

export const ButtonAction = tw.button`
inline-flex
items-center
justify-center
h-[38px]
py-2
px-4
border
border-blueTheme
rounded-lg
text-sm
active:scale-95
transition-colors
cursor-pointer
hover:brightness-90
`
export const HelpDescription = tw.p`
text-darkGray/80 
text-xs
leading-[18px]
w-[1120px] 
`
export const inputRequiredStyle = `
border
border-errorText
focus:ring-0
focus:border
focus:border-errorText
`